<template>
  <div class="app-container">
    <navigation title="在借信息"></navigation>
    <div class="list" v-if="isShow">
      <van-list>
        <van-cell v-for="item in list" :title="item.title">
          <template #label>
            <p class="message" v-if="item.callNo">索书号：{{item.callNo}}</p>
            <p class="message" v-if="item.dueDate">应还日期：{{item.dueDate}}</p>
            <p class="message" v-if="item.residue>=0">剩余：{{item.residue}}天</p>
            <p class="message" v-else>已逾期请尽快还书</p>
          </template>
          <template #right-icon>
            <van-button v-if="item.renewal!=='N' && item.renewalStatus!=='Y' && item.residue>=0" class="again" @click="again(item.barcode)">续借</van-button>
            <van-button v-if="item.renewal!=='N' && item.renewalStatus==='Y'" class="again-no" >已续借</van-button>
          </template>
        </van-cell>
      </van-list>
    </div>
    <div class="no-list" v-else>
      <img src="@/assets/img/no-collection.png" alt="">
      <p>您还没有在借图书</p>
    </div>
    <version></version>
    <scroll></scroll>
  </div>
</template>

<script>
import Vue from 'vue'
import {Cell, CellGroup, List, Icon, Checkbox, Toast} from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'again',
  components: {navigation, version, scroll},
  data () {
    return {
      list: [],
      isShow: true
    }
  },
  created () {
    window.scrollTo(0,0);
    // 获取借阅历史
    this.getList()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getList () {
      Toast.loading({
        message: '加载中...'
      });
      request('post', '/nlc-api/api/nlc/borInfoI').then(res => {
        console.log('借阅列表', res)
        if(res.code===200){
          res.data.forEach(item=>{
            let now = new Date()
            let dueDate = new Date(item.dueDate)
            let usedTime = now - dueDate
            let days=Math.floor(usedTime/(24*3600*1000))
            if(days<=0){
              item.residue = Math.abs(days)
            } else {
              item.residue = -days
            }
          })
          this.list = res.data
          this.$nextTick(()=>{
            Toast.clear()
          });
          if(this.list.length === 0){
            this.isShow = false
          }
        } else {
          this.isShow = false
        }
      }).catch(e => {
        Toast.clear()
      })
    },
    // 续借
    again (barcode) {
      Toast.loading({
        message: '加载中...'
      });
      var params = {
        barcode: barcode
      }
      request('post', '/nlc-api/api/nlc/renew', params).then(res => {
        console.log('续借', res)
        Toast.clear()
        if (res.code===200) {
          this.getList()
          Toast('续借成功')
        } else {
          Toast(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ECF5FD;
  padding-top:.92rem;
}
.list{
  width:6.94rem;
  min-height:12.28rem;
  margin:.16rem .28rem;
  border-radius:8px;
  background:#fff;
}
.van-cell__title{
  font-size:.3rem;
  color:#444649;
}
>>>.van-cell__label{
  font-size:.28rem;
}
.message{
  line-height:.14rem;
}
.state{
  font-size:.24rem;
  color:#94979C;
}
.state-return{
  color:#008095;
}
.again{
  width:1rem;
  height:.48rem;
  border-radius: .6rem;
  /*color: #008095;*/
  font-size:.28rem;
  position: absolute;
  right: .3rem;
  bottom: .15rem;
  font-family: SourceHanSerifCN-Bold;
}
.van-button--normal{
  padding:0;
}
.van-cell{
  border-radius:8px;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
}
.no-list{
  width:6.94rem;
  height:12.28rem;
  background:#fff;
  border-radius:8px;
  margin:.16rem .28rem;
  font-size: .28rem;
  font-family: SourceHanSerifCN-Light;
  color: rgba(51, 51, 51, 0.4);
  text-align:center;
}
.no-list img{
  width:3.27rem;
  height:3.84rem;
  margin-top:3.8rem;
}
.again-no{
  font-size:.28rem;
  position: absolute;
  right: .3rem;
  bottom: .15rem;
  font-family: SourceHanSerifCN-Bold;
  background:none;
  border:0;
}
</style>



// WEBPACK FOOTER //
// src/view/again/index.vue